import React, {forwardRef, Fragment} from 'react';
import cn from 'classnames';
// import SvgIcon from '../../../common/SvgIcon';
// import ReviewsIoWidget from "./ReviewsIoWidget";

// const stopPropagation = e => {
//   e.preventDefault();
//   e.stopPropagation();
// };

const YouReceive = (
  { value, className },
  ref,
) => {
  // const notStyling = value.find(v => v.type != "room_styling");
  // const styling = value.find(v => v.type === "room_styling");
  return (
    <Fragment>

      <div ref={ref} className={cn('brief_step -rooms', className)}>
        {/*<div className="brief_step-title-wrapper">*/}
        {/*  <h2 className="brief_step-title">*/}
        {/*    {"Great choice!"}*/}
        {/*  </h2>*/}
        {/*  /!*<div className="brief_step-note">Select as many as you wish</div>*!/*/}
        {/*</div>*/}
        {/*{notStyling && (*/}
        {/*  <div className="brief_rooms_you-receive">*/}
        {/*    <div className="title"> Included with every Room Design package: </div>*/}
        {/*    <ul>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Professional interior designer handpicked for you</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>3 weeks one-on-one collaboration</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>2 x 40 mins video calls</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Space planning to nail the perfect room layout</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Tailored colour schemes and mood board</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Handpicked furniture recommendations to your budget</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>2D visuals so you can visualise the space</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Designer video presentation with top tips</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>2 weeks post design support with your designer</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Shopping support on orders & deliveries, for as long as you need</li>*/}

        {/*      /!*<li className="subtitle">PLUS....you’ll save money</li>*!/*/}
        {/*      /!*<li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Exclusive discounts of up to 25% on your items</li>*!/*/}
        {/*      /!*<li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>A £100 shopping voucher, valid on spend over £2,000</li>*!/*/}
        {/*    </ul>*/}
        {/*  </div>*/}
        {/*)}*/}
        {/*{styling && (*/}
        {/*  <div className="brief_rooms_you-receive">*/}
        {/*    <div className="title">Included with every Room Styling package:</div>*/}
        {/*    <ul>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Professional interior designer handpicked for you</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>3 weeks one-on-one collaboration</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>1 x 40 mins video calls</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Tailored colour schemes and mood board</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Handpicked accessory recommendations for 6 categories</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Designer video presentation with top tips</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>1 weeks post design support with your designer</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Shopping support on orders & deliveries, for as long as you need</li>*/}

        {/*      <li className="subtitle">PLUS....you’ll save money</li>*/}
        {/*      <li><span className="tick"><SvgIcon icon="tick-2023-09" /></span>Exclusive discounts of up to 25% on your items</li>*/}
        {/*    </ul>*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>
      {/*<ReviewsIoWidget />*/}
    </Fragment>
  );
};

export default forwardRef(YouReceive);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefYouReceivePage.js